import { Avatar } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
function WorkerAvatar({ id }) {
    if (!id)
        return (React.createElement(Avatar, null,
            React.createElement(PersonIcon, null)));
    return React.createElement(Avatar, { src: `/api/kbi/workers/${id}/photo` });
}
export default React.memo(WorkerAvatar);
